import React from "react";
import Lottie from "lottie-react";
import { frasesNegativasEvaluacion, frasesPositivasEvaluacion } from "../utils/frases";
import { lottiesNegativosEval, lottiesPositivosEval } from "../services/lottieService";
import "../styles/ReporteCalificacion.css";


const ReporteCalificacion = ({ puntaje, onContinuar, colorPrincipal }) => {
  const estilo = { "--color-principal": colorPrincipal };
  //console.log("Color principal recibido en Reporte Calificacion: ", colorPrincipal);
  function obtenerTitulo(puntaje) {
    if (puntaje >= 7) {
      return "Ejercicio completado!";
    } else {
      return "Ejercicio NO completado!"
    }
  }

  function obtenerFrase(puntaje) {
    if (puntaje >= 7) {
      return frasesPositivasEvaluacion[Math.floor(Math.random() * frasesPositivasEvaluacion.length)];
    } else {
      return frasesNegativasEvaluacion[Math.floor(Math.random() * frasesNegativasEvaluacion.length)];
    }
  }

  function obtenerLottie(puntaje) {
    if (puntaje >= 7) {
      return lottiesPositivosEval[Math.floor(Math.random() * lottiesPositivosEval.length)];
    } else {
      return lottiesNegativosEval[Math.floor(Math.random() * lottiesNegativosEval.length)];
    }
  }

  function obtenerEtiqueta(puntaje) {
    if (puntaje == 10) {
      return "Excelente";
    } else if (puntaje == 9) {
      return "Muy bien";
    } else if (puntaje == 8) {
      return "Bien";
    } else if (puntaje == 7) {
      return "Aprobado";
    } else {
      return "Muy mal";
    }
  }

  const lottieAnim = obtenerLottie(puntaje);
  return (
    <div className="reporte-container" style={estilo}>
      <h2 className="reporte-titulo">{obtenerTitulo(puntaje)}</h2>

      {/* Animación */}
      <div className="reporte-lottie">
        <Lottie animationData={lottieAnim} loop={false} style={{ height: 140 }} />
      </div>

      <p className="reporte-frase">{obtenerFrase(puntaje)}</p>

      {/* Calificación */}
      <div className="reporte-calificacion">
        <span className="reporte-label">{obtenerEtiqueta(puntaje)}</span>
        <span className="reporte-score">{puntaje}</span>
      </div>

      {/* Botón continuar */}
      <div>
        <button className="btn-primary-reporte" onClick={onContinuar}>
          CONTINUAR
        </button>
      </div>
    </div>
  );
};

export default ReporteCalificacion;
